import React from 'react';
import PropTypes from 'prop-types';

import Subtitle from 'ui/text/Subtitle';
import Description from 'ui/text/Description';

import ButtonGroup from 'components/OfferCardButtonGroup';
import OfferCardSettings from 'components/OfferCardSettings';

import useSliderController from 'utils/useSliderController';

import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';

const TicketCard = ({ ticket, onAction, requires_approval, cartMode, showThumb = true }) => {

    const {title, description, show_end_date, show_supply, end_date, issued_counter, supply_limit, image_urls} = ticket;

    const showSettings = show_end_date || show_supply;
    const hasImage = Array.isArray(image_urls) && image_urls.length > 0;

    const { handleImageClick, SliderComponent } = useSliderController(title, description);

    const onThumbClick = hasImage ? () => handleImageClick(image_urls) : undefined;

    return (
      <div className={`ticket-card${showThumb ? '' : ' no-thumb'}`}>
        {showThumb &&
          <div
            className={`ticket-thumb${hasImage ? '' : ' placeholder'}`}
            onClick={onThumbClick}
            role={hasImage ? 'button' : undefined}
            tabIndex={hasImage ? 0 : undefined}
            aria-label={hasImage ? title : undefined}
          >
            {hasImage
              ? <img src={image_urls[0]} alt={title} />
              : <ConfirmationNumberOutlinedIcon fontSize="medium" />
            }
          </div>
        }

        <div className="ticket-card-content">
          <div className="ticket-info">
            <Subtitle small>{title}</Subtitle>

            {description && <Description>{description}</Description>}

            {showSettings &&
              <OfferCardSettings
                end_date={show_end_date ? end_date : null}
                issued_counter={issued_counter}
                supply_limit={show_supply ? supply_limit : null} />
            }
          </div>

          <ButtonGroup
            product={ ticket }
            onAction={ onAction }
            requires_approval={requires_approval}
            cartMode={cartMode}
            layout="horizontal"
          />
        </div>

        <SliderComponent />
      </div>
    );
};

TicketCard.propTypes = {
  ticket: PropTypes.object,
  onAction: PropTypes.func,
  requires_approval: PropTypes.bool,
  cartMode: PropTypes.bool,
  showThumb: PropTypes.bool
};

export default TicketCard;
